


























import {
    useVuexStore,
    useVueRouter,
} from '@superbet-group/web.lib.vue-utilities';
import {
    computed,
    defineComponent,
    onMounted,
    ref,
    watch,
} from '@vue/composition-api';
import promotionStoreIndex from '@store/modules/ui/user/promotions/promotionIndex';
import PromotionActiveCard from './PromotionActiveCard.vue';
import { PromotionHubQuickFilter } from '@app/promotionHub/shared/utils/promotionHubQuickFilters';
import PromotionsInfoPage from '@pages/PromotionsInfoPage.vue';
import {
    SdsContentLoader,
    SdsEmptyScreen,
} from '@superbet-group/web.lib.ui-components';

export default defineComponent({
    name: 'PromotionOffers',
    props: {
        arePromotionsLoading: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    setup() {
        const { route } = useVueRouter();

        const expandedPromotionId = ref<string | null>(null);

        const promoModule = useVuexStore<typeof promotionStoreIndex>('ui/user/promotions');
        const promotions = promoModule.state('availablePromotions');
        const promotionHubActiveQuickFilter = promoModule.state('promotionHubActiveQuickFilter');

        onMounted(() => {
            expandedPromotionId.value = (route.value.query.promoId as string) ?? null;
        });

        watch(() => route.value, (val) => {
            if (val.query.promoId) {
                expandedPromotionId.value = (route.value.query.promoId as string) ?? null;
            }
        });

        return {
            areNonStopPromotionsVisible: computed(() => promotionHubActiveQuickFilter.value === PromotionHubQuickFilter.NonStop),
            promotions: computed(() => promotions.value.map((p) => ({
                ...p,
                isExpanded: p.promotionInstanceId === expandedPromotionId?.value,
            }))),
        };
    },
    components: {
        PromotionActiveCard,
        PromotionsInfoPage,
        SdsContentLoader,
        SdsEmptyScreen,
    },
});
